import { Option } from "@performyard/py-components";
import { Timeframe } from "@performyard/service-contracts";

export type SectionId = "summary" | "coaching" | "reviews" | "goals" | "competencies" | "feedback" | "meetings";

export type SectionGates = {
	reviewsEnabled: boolean;
	goalsEnabled: boolean;
	feedbackEnabled: boolean;
	competenciesEnabled: boolean;
	meetingsEnabled: boolean;
	coachingEnabled: boolean;
	isSelfView: boolean;
};

export type SectionDescriptor = {
	id: SectionId;
	label: string;
	cardTitle?: string;
	isVisible: (gates: SectionGates) => boolean;
};

export const SECTIONS: ReadonlyArray<SectionDescriptor> = [
	{ id: "summary", label: "Summary", isVisible: () => true },
	{
		id: "coaching",
		label: "Coaching",
		cardTitle: "Coaching Recommendations",
		isVisible: (gates) => gates.coachingEnabled && !gates.isSelfView,
	},
	{ id: "reviews", label: "Reviews", isVisible: (gates) => gates.reviewsEnabled },
	{ id: "competencies", label: "Competencies", isVisible: (gates) => gates.competenciesEnabled },
	{ id: "goals", label: "Goals", isVisible: (gates) => gates.goalsEnabled },
	{ id: "feedback", label: "Feedback", isVisible: (gates) => gates.feedbackEnabled },
	{ id: "meetings", label: "Meetings", isVisible: (gates) => gates.meetingsEnabled },
];

export const TIMEFRAME_OPTIONS: ReadonlyArray<Option<Timeframe>> = [
	{ label: "Overall", value: "all" },
	{ label: "30 Days", value: "30d" },
	{ label: "90 Days", value: "90d" },
	{ label: "12 Months", value: "12mo" },
];
